import WebFont from 'webfontloader'

const options = {"custom":{"families":["Muli:n4,n7","Din:n7"],"urls":["https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Muli:wght@400;700&display=swap"]}}

WebFont.load(options)
